import React from 'react';

import { Box, Stack } from '@liscio/ui';

import {
  GoogleOAuthV5Login,
  OutlookOAuthV5Login,
} from 'modules/authenticate/components/OAuth';

export const OAuthButtonRow = () => {
  return (
    <Stack gap={2}>
      <Box display="flex" flexDirection="column">
        <GoogleOAuthV5Login />
      </Box>
      <Box display="flex" flexDirection="column">
        <OutlookOAuthV5Login />
      </Box>
    </Stack>
  );
};
